<app-perform-test
  *ngIf="studiesDetails"
  [initialState]="phantomTestingState"
  [data]="studiesDetails"
></app-perform-test>
